import { gql } from '@apollo/client';

export const FORM_FIELD = gql`
  fragment FormFieldFragment on Form {
    id
    title
    fields {
      ... on Checkbox {
        name
        label
        width
        required
        defaultValueBoolean: defaultValue
        id
        blockName
        blockType
      }
      ... on Email {
        name
        label
        width
        required
        id
        blockName
        blockType
      }
      ... on Message {
        message
        id
        blockName
        blockType
      }
      ... on Number {
        name
        label
        width
        defaultValueNumber: defaultValue
        required
        id
        blockName
        blockType
      }
      ... on Select {
        name
        label
        width
        defaultValue
        options {
          label
          value
          id
        }
        required
        id
        blockName
        blockType
      }
      ... on Toggle {
        name
        label
        width
        defaultValue
        options {
          label
          value
          id
        }
        required
        id
        blockName
        blockType
      }
      ... on Text {
        name
        label
        width
        defaultValue
        required
        id
        blockName
        blockType
      }
      ... on Textarea {
        name
        label
        width
        defaultValue
        required
        id
        blockName
        blockType
      }
    }
    submitButtonLabel
    confirmationType
    confirmationMessage
    redirect {
      url
    }
    updatedAt
    createdAt
  }
`;
